module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"title":"Cookie Policy","text":"TRAC19 utilizza cookie o tecnologie simili come specificato nella Cookie Policy. Clicca su ‘Accetto’ per acconsentire all’utilizzo di tali tecnologie ed utilizzare TRAC19.","link":"Scopri di più","button":"Accetto"}}')
  delete Component.options._Ctor
}
